import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(private http: HttpClient) {
  }
  post(serviceName: string, data: any) {
    const headers = new HttpHeaders();
    let clientDate = new Date();
    /*var res = UtcDate.toString().match(/[\+,\-](\d{4})\s/g);
    let clientDate = UtcDate.getFullYear() + "-" + (UtcDate.getMonth() + 1) + "-" + UtcDate.getDate() + " " + UtcDate.getHours() +
    ":" + UtcDate.getMinutes() + ":" + UtcDate.getSeconds() + "," + res[0];
    let timeZone =  Number(res[0]);*/
    let timeLocal = clientDate.toLocaleString();
    let timeUtc = clientDate.toLocaleString('en-GB', { timeZone: 'UTC' });
    console.log("Time local: ", timeLocal);
    console.log("Time UTC: ", timeUtc);
    const options = { headers: headers, withCredintials: false };
    const url = environment.host + serviceName;
    //const url = "http://localhost:8888/cronoleoyii2" + serviceName; // test
    console.log("DATA send:",(data));

    //cambiar apuntar a yii
    console.log("Cambiar AQUI!!!!!!!!!",url);
    //******************************* */

    //******************************* */
    return new Promise(async (resolve,reject)=>{
      try {

        const response = await fetch(url, {
          method: "POST",
          body: (data),
        });
        //return response.json(); // parses JSON response into native JavaScript objects
        resolve(response.json())

        /* this.http.post(url, (data), options).pipe(
          map((response: any) => {
            // Puedes manipular la respuesta aquí si es necesario
            console.log('Datos recibidos:', response);
            resolve(response) ;
          }),
          catchError((error): any => {
            console.log('error recibidos:');
            resolve(throwError(() => new Error("error.message" || 'Server error')));
          })
        ); */
        
        /* this.http.post(url, (data), options).subscribe({
          next: (response) => {
            console.log('Respuesta del servidor:', response);
            resolve(response)
          },
          error: (err) => {
            console.error('Error:', true);
            let Error = { error: true }
            let responseJson = false;
            try {
              Error = JSON.parse(err)
            } catch (error) {
              Error = { error: true }
            }
            if(err instanceof Object){
              console.error('Error: is object', true);
              
            }
            resolve(Error)
          }
        }); */
        setTimeout(() => {
          let Error = { error: true }
          reject(Error)
        }, 30000);
        
        /* this.http.post(url, (data), options).subscribe((response:any)=>{
          console.log("post subscribe");
          resolve(response) 
        },error=>{
          console.log("post error");
          reject({error:null})
        }) */
      } catch (error) {
        console.log("post catch",error);
        reject(error)
      }
      
    })
    try {
      
      if(data instanceof FormData){
        return this.http.post(url, (data), options);
      }
      return this.http.post(url, JSON.stringify(data), options);
    } catch (error) {
      return error
    }
    
  }
  async postServer(serviceName: string, data: any) {
    const headers = new HttpHeaders();
    //console.log("refreshToken postServer: "+JSON.stringify(data.refresh_token));
    const url = environment.host + serviceName;
    return await this.http.post(url, JSON.stringify(data.refresh_token), null);
  }
}
